import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import Ripple from '@/components/Ripple'

// 卡片操作类型枚举
export enum CardActionType {
    Recharge = 'recharge',
    Transfer = 'transfer',
    Info = 'info',
    Manage = 'manage'
}

// 卡片操作项接口
export interface CardActionItem {
    icon: string
    title: string
    actionType: CardActionType
}

export interface CardActionsProps {
    /** 操作点击回调 */
    onActionClick?: (actionType: CardActionType) => void
    /** 自定义类名 */
    className?: string
}

const CardActions: React.FC<CardActionsProps> = ({
    onActionClick,
    className = ''
}) => {
    const { t } = useTranslation()

    const actionItems = useMemo<CardActionItem[]>(() => [
        {
            icon: '/images/card-v2/card-recharge-icon.svg',
            title: t('充值'),
            actionType: CardActionType.Recharge
        },
        {
            icon: '/images/card-v2/card-transfer-icon.svg',
            title: t('转出'),
            actionType: CardActionType.Transfer
        },
        {
            icon: '/images/card-v2/card-info-icon.svg',
            title: t('信息'),
            actionType: CardActionType.Info
        },
        {
            icon: '/images/card-v2/card-manage-icon.svg',
            title: t('管理'),
            actionType: CardActionType.Manage
        }
    ], [t])

    return (
        <div className={`flex justify-between items-start px-5 ${className}`}>
            {actionItems.map(item => (
                <div
                    key={item.actionType}
                    onClick={() => onActionClick?.(item.actionType)}
                    className="flex flex-col items-center py-2 cursor-pointer"
                >
                    {/* 圆形图标背景 */}
                    <Ripple className="rounded-2xl">
                        <div className="w-14 h-14 rounded-2xl flex items-center justify-center bg-[#F4F6F9]">
                            <img
                                src={item.icon}
                                alt={item.title}
                                className="w-6 h-6"
                            />
                        </div>
                    </Ripple>
                    {/* 标题 */}
                    <span className="text-xs mt-2 text-center text-[#1D2129]">
                        {item.title}
                    </span>
                </div>
            ))}
        </div>
    )
}

export default CardActions
